import { Link } from 'react-router-dom';

export default function PreFooterCTA() {
  return (
    <section className="relative py-32 bg-[#2C2C2C] overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      {/* Faded Project Photos */}
      <div className="absolute top-0 left-0 w-64 h-64 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/549a468667a7ae58050128bd06d14403.jpg"
          alt=""
          className="w-full h-full object-cover rounded-full blur-sm"
        />
      </div>
      <div className="absolute bottom-0 right-0 w-64 h-64 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=stone%20paver%20pattern%20texture%20in%20minimalist%20style%20with%20simple%20clean%20background&width=400&height=400&seq=footer002&orientation=squarish"
          alt=""
          className="w-full h-full object-cover rounded-full blur-sm"
        />
      </div>

      <div className="max-w-[1000px] mx-auto px-6 text-center relative z-10">
        <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          Let's Create Your Outdoor Oasis
        </h2>
        <p className="text-2xl text-gray-300 mb-12">
          Schedule your free consultation today
        </p>
        <Link to="/estimate" className="inline-block bg-[#E67E22] text-white px-12 py-6 rounded-full text-xl font-bold hover:bg-[#D35400] transition-all shadow-2xl mb-8 whitespace-nowrap cursor-pointer">
          Request Free Estimate
        </Link>
        <div className="mb-4">
          <a href="tel:6105550123" className="text-3xl font-bold text-white hover:text-[#E67E22] transition-colors flex items-center justify-center gap-3 cursor-pointer">
            <i className="ri-phone-line"></i>
            (610) 555-0123
          </a>
        </div>
        <p className="text-sm text-gray-400">Average response time: Under 2 hours</p>
      </div>
    </section>
  );
}